import { useNode } from '@craftjs/core';
import { FormTextInputComponent } from 'src/features/generalForms/builder/types/TextInput';
import { HookFormTextField } from 'src/features/generalForms/uikit/hookFormFields/hookFormTextField';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';

export const FormTextInput: FormTextInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div style={styles}>
      <HookFormTextField
        control={form.control}
        name={props.dataKey!}
        maxLength={props.maxLength}
        type={props.type}
        disabled={isDisabled}
        placeholder={props.placeholder}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
          maxLength: props.maxLength,
          pattern: props.pattern,
          max: props.maxValue,
          min: props.minValue,
        })}
        errorProps={{ errors }}
      />
    </div>
  );
};
